// @flow
import { Dispatch } from 'redux';
import { createEffect } from '../../stream-effects/virtual-background';
import { checkFilterSupport } from '../../../features/face-recognition/functions';

import logger from './logger';

/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promsie} - A Promise which resolves when all effects are created.
 */
export default function loadEffects(store: Object): Promise<any> {
    const state = store.getState();
    const virtualBackground = state['features/virtual-background'];
    const faceRecognition =  state['features/face-recognition'];

    const backgroundPromise = virtualBackground.backgroundEffectEnabled
        ? createEffect(virtualBackground)
            .catch(error => {
                logger.error('Failed to obtain the background effect instance with error: ', error);

                return Promise.resolve();
            })
        : Promise.resolve();

    const faceRecognitionPromise = checkFilterSupport(state)
        ? createEffect(faceRecognition)
            .catch(error => {
                logger.error('Failed to obtain the face recognition effect instance with error: ', error);

                return Promise.resolve();
            })
        : Promise.resolve();

    return Promise.all([ backgroundPromise, faceRecognitionPromise ]);
}
